import { render } from "./BlListFilterSelectManyToMany.vue?vue&type=template&id=725e92f0&scoped=true"
import script from "./BlListFilterSelectManyToMany.vue?vue&type=script&lang=js"
export * from "./BlListFilterSelectManyToMany.vue?vue&type=script&lang=js"

import "./BlListFilterSelectManyToMany.vue?vue&type=style&index=0&id=725e92f0&scoped=true&lang=scss"

import exportComponent from "/var/www/blocks/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-725e92f0"]])

export default __exports__